import { Button } from '@hivebrite/design-system/Button';
import { DefaultLink } from '@hivebrite/design-system/Link';

const AppHeaderLinkButton = ({
  label,
  isPreview,
  url,
  variant = 'primary',
  target = '_blank',
}) => {
  if (isPreview) {
    return <Button variant={variant}>{label}</Button>;
  }

  return (
    <DefaultLink href={url} target={target}>
      <Button variant={variant}>{label}</Button>
    </DefaultLink>
  );
};

export default AppHeaderLinkButton;

AppHeaderLinkButton.defaultProps = {
  isPreview: false,
};
